import ProfilePreviewPage from 'features/manfredite-profile/ManfrediteProfilePage';
import { ManfrediteProfilePageProps } from 'features/manfredite-profile/ManfrediteProfilePage.types';
import { usePageTrack } from 'hooks/usePageTrack';
import { isProfileViewType } from 'interfaces/public-manfredite.interface';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { DEFAULT_LOCALE } from 'services/multilingual.service';
import { ServiceProfilePageInfo } from 'services/service-profile-page-info';
import { getLoggedUserToken } from 'utils/access-token';
import {
  APP_URLS,
  getAppUrl,
  getNotFoundUrl,
  getSSRRedirectionTo
} from 'utils/app-urls';
import { createGetServerSideProps } from 'utils/ssr';

const Page: React.FC<ManfrediteProfilePageProps> = (props) => {
  usePageTrack('Public Profile - Page Loaded');

  return <ProfilePreviewPage {...props} />;
};

export default Page;

export const getServerSideProps = createGetServerSideProps(
  async ({ locale, params, req, res }) => {
    const redirect404 = getSSRRedirectionTo<ManfrediteProfilePageProps>(
      getNotFoundUrl(locale)
    );

    const slug = params?.slug?.toString();
    const view = params?.view?.toString();

    if (!slug) {
      return redirect404;
    }

    if (!view || !isProfileViewType(view)) {
      return getSSRRedirectionTo<ManfrediteProfilePageProps>(
        `${getAppUrl(APP_URLS.manfrediteProfileV2, locale)}/${slug}`
      );
    }

    const accessToken = await getLoggedUserToken(req, res);
    const result = await ServiceProfilePageInfo.get({
      slug,
      accessToken,
      view
    });

    if (!result) {
      return redirect404;
    }

    const { publicManfredite, showToolbar, publicProfileActive } = result;

    return {
      props: {
        ...(await serverSideTranslations(
          (
            publicManfredite.preferredLanguage ||
            locale ||
            DEFAULT_LOCALE
          ).toLowerCase(),
          ['common', 'publicProfile', 'profile-preview', 'portal-layout']
        )),
        publicManfredite,
        slug,
        showToolbar,
        publicProfileActive,
        view
      }
    };
  }
);
